import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "../CookieConsentProvider";

// Load environment variables
declare global {
  interface Window {
    embeddedChatbotConfig?: {
      chatbotId: string;
      domain: string;
    };
  }
}

const Chatbase = () => {
  const { pathname } = useLocation();
  const { chatbase } = useCookieConsent();

  useEffect(() => {
    if (chatbase) {
      if (pathname.startsWith("/checkout")) {
        // Remove elements with id starting with "chatbase-bubble"
        document
          .querySelectorAll('[id^="chatbase-bubble"]')
          .forEach((element) => {
            (element as HTMLElement).style.visibility = "hidden";
          });

        // Remove elements with id starting with "chatbase-message"
        document
          .querySelectorAll('[id^="chatbase-message"]')
          .forEach((element) => {
            (element as HTMLElement).style.visibility = "hidden";
          });
      } else {
        document
          .querySelectorAll('[id^="chatbase-bubble"]')
          .forEach((element) => {
            (element as HTMLElement).style.visibility = "visible";
          });

        // Making elements with id starting with "chatbase-message" visible
        document
          .querySelectorAll('[id^="chatbase-message"]')
          .forEach((element) => {
            (element as HTMLElement).style.visibility = "visible";
          });
      }
    }
  }, [pathname, chatbase]);

  return null;
};

export default Chatbase;
